module.exports = __webpack_public_path__ + "static/media/free-root-beer-2024-mb-en.1d824efa.jpg";